<template>
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >        
    <v-flex xs6 class="inline-block px-4">            
      <v-text-field type="password" :label="$t('Admin.User.Password.Password')" v-model="password" />    
      <v-text-field type="password" :label="$t('Admin.User.Password.ConfirmPassword')" v-model="confirmPassword" />    
    </v-flex>                             
  </v-layout>          
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminUserPassword'
})
export default class AdminUserPassword extends Vue {  
    
  public password:string = ""
  public confirmPassword:string = ""
  
  get original() {
    return this.$store.myGetters.originalAdmUser
  }
    
  public changePassword() {
    if(this.password == this.confirmPassword && this.password.length >= 8) {    
      this.$store.myActions.USER_CHANGE_PASSWORD_REQUEST({
        usrId:this.original.USR_ID!,
        oldPassword:null,
        newPassword:this.password
      })
    }   
    else {
      alert("Password mismatch or must be at least 8 characters")
    }
  }

  public reset(){    
    this.password = ""
    this.confirmPassword = ""
  }
}
</script>